import React from 'react'

export const DropdownPropsContext = React.createContext(undefined)
export const DropdownHandlersContext = React.createContext(undefined)
